export const AUTHOR_FORM_CONSTS = {
  createAuthor: 'Создание автора',
  editAuthor: 'Редактирование автора',
  fullName: {
    label:'ФИО', 
    placeholder: 'Введите имя, либо ИФ, либо ФИО'
  },
  jobTitle: {
    label:'Должность', 
    placeholder: 'Введите должность'
  },
  email: {
    label:'Email', 
    placeholder: 'Введите email'
  },
  editor: {
    label:'Редакция', 
    defaultValue: 'Выберите редакцию'
  },
  description: {
    label:'Описание', 
    placeholder: 'Введите описание'
  },
  isActive: 'Показывать на сайте',
  status: 'Уволить сотрудника', 
  saveText: 'Сохранить изменения',
  publicationNone: 'Публикации отсутствуют',
  invalidMail: 'Некорректный email',
  invalidFullName: 'Введите имя'
}
